import {
  Download1Stroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_ton_kho_phieu_xuat_dieu_chuyen_PXDC } from '@/lib/templates-base64/PXDC';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { usePhieuXuatDieuChuyenContext } from '../context';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onSearchClick: () => void;
  onRefreshClick: () => void;
  onPrintClick: () => void;
}

export const ActionBar = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onSearchClick,
  onRefreshClick,
  onPrintClick
}: ActionBarProps) => {
  const { exportToExcel, canExport, isExporting, import: importContext } = usePhieuXuatDieuChuyenContext();
  const { openImportDialog } = importContext;

  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(excelTemplate_ton_kho_phieu_xuat_dieu_chuyen_PXDC, 'Phiếu xuất điều chuyển.xlsx');
  };

  return (
    <ActionBarV2 title='Phiếu xuất điều chuyển'>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} />
      <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopyClick} />
      <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrintClick} />
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} />
      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: openImportDialog,
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};
